
import Button from "../Button";
import MultiSelectDropdown from "../MultiSelectDropdown";
import CreatableMultiSelect from "../CreatableMultiSelect";
import { Modal } from "../Modal/index.jsx";
import { useState, useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";
import { supabase } from "../../supabaseClient"; // adjust path
import { AsyncPaginate } from "react-select-async-paginate";
import Creatable from "react-select/creatable";
import { withAsyncPaginate } from "react-select-async-paginate";
import countryList from "react-select-country-list";
import Select from "react-select";

const ConfirmTagModal = ({ show, onClose, onConfirm, pendingValue }) => {
  if (!show) return null;

  return (
    <Modal showModal={show} setShowModal={onClose}>
      <div className="p-6">
        <h2 className="text-lg font-semibold mb-4">Confirm Add Tag</h2>
        <p className="mb-6 text-gray-600">
          Are you sure you want to add "<strong>{pendingValue}</strong>" as a tag?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Yes, Add Tag
          </button>
        </div>
      </div>
    </Modal>
  );
};

const StepAdditionalMetadata = ({
  formData,
  genreOptions,
  genreLoadOptions,
  languagesLoadOptions,
  directorLoadOptions,
  handleDropdownChange,
  languagesOptions,
  castOptions,
  castLoadOptions,
  directorOptions,
  tagsOptions,
  handleBack,
  handleNext,
  setGenreOptions,
  setLanguagesOptions,
  setCastMembersOptions,
  setDirectorsOptions,
}) => {
  const [showTagConfirm, setShowTagConfirm] = useState(false);
  const [pendingTagValue, setPendingTagValue] = useState("");

  const { isDark } = useTheme();

  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 999 }),
    control: (base) => ({
      ...base,
      backgroundColor: isDark ? "#161b22" : "#fff",
      borderColor: isDark ? "#4b5563" : "#d1d5db",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: isDark ? "#161b22" : "#fff",
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: isDark ? "#161b22" : "#fff",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: isDark
        ? state.isFocused ? "rgba(59,130,246,0.15)" : "#161b22"
        : state.isFocused ? "#f3f4f6" : "#fff",
      color: isDark ? "#e6edf3" : "#111827",
    }),
    input: (base) => ({ ...base, color: isDark ? "#e6edf3" : "#111827" }),
    singleValue: (base) => ({ ...base, color: isDark ? "#e6edf3" : "#111827" }),
    placeholder: (base) => ({ ...base, color: isDark ? "#6b7280" : "#9ca3af" }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: isDark ? "rgba(59,130,246,0.2)" : "#dbeafe",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: isDark ? "#e6edf3" : "#1d4ed8",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: isDark ? "#e6edf3" : "#1d4ed8",
      ":hover": { backgroundColor: "rgba(239,68,68,0.2)", color: "#ef4444" },
    }),
  };

  const CreatableAsyncPaginate = withAsyncPaginate(Creatable);

  const loadTags = async (search, loadedOptions, { page }) => {
    const pageSize = 10;



    let query = supabase
      .from("tiles")
      .select("tags")
      .order("id", { ascending: false })
      .range((page - 1) * pageSize, page * pageSize - 1);

    if (search) {
      query = query.ilike("tags::text", `%${search}%`);
    }

    const { data, error } = await query;

    if (error) {
      console.error(error);
      return { options: [], hasMore: false, additional: { page } };
    }

    // extract tags safely
    let tags = data.flatMap((row) => {
      const raw = row.tags;
      if (!raw) return [];
      try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    });

    // search filter
    if (search) {
      tags = tags.filter((tag) =>
        tag.toLowerCase().includes(search.toLowerCase())
      );
    }

    // remove duplicates that were already loaded
    const loaded = new Set(loadedOptions.map((opt) => opt.value));
    const uniqueNewTags = [...new Set(tags)].filter((t) => !loaded.has(t));

    const options = uniqueNewTags.map((t) => ({ value: t, label: t }));

    // 🔥 STOP if no new tags found
    const hasMore = uniqueNewTags.length > 0;

    return {
      options,
      hasMore,
      additional: { page: page + 1 },
    };
  };
  const handleSubmit = async () => {
    const tagsToSave = Array.isArray(formData.tags) ? formData.tags : [];

    if (formData.id) {
      const { error } = await supabase
        .from("tiles")
        .update({ tags: JSON.stringify(tagsToSave) })
        .eq("id", formData.id);

      if (error) {
        console.error("❌ Update failed:", error);
      } else {
        console.log("✅ Tags updated:", tagsToSave);
      }
    } else {
      console.warn(
        "⚠️ No ID available—skipping DB save for tags. Will save on full form submit."
      );
    }
  };

  const mapWithFallback = (values, options, setOptions) => {
  return (values || []).map(val => {
    const id = typeof val === "object" ? val.value : val;

    let found = options.find(opt => opt.value === id);

    if (!found && id) {
      const newOption = { value: id, label: id };

      setOptions(prev => {
        if (prev.some(opt => opt.value === id)) return prev;
        return [...prev, newOption];
      });

      found = newOption;
    }

    return found;
  });
};

      const isUUID = (val) =>
  typeof val === "string" &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val);

  const normalizeRuntime = (value) => {
    if (!value) return "";

    const parts = value.split(":");

    if (parts.length === 3 && parts.every((p) => p.length === 2)) return value;

    const [h = "00", m = "00", s = "00"] = parts;
    const hh = h.padStart(2, "0");
    const mm = m.padStart(2, "0");
    const ss = s.padStart(2, "0");

    return `${hh}:${mm}:${ss}`;
  };

  // Fixed TimePicker Component
  const TimePicker = ({ value, onChange }) => {
    // Initialize state from value or default to "00:00:00"
    const [time, setTime] = useState(() => {
      const normalized = normalizeRuntime(value);
      const [hours, minutes, seconds] = normalized
        ? normalized.split(":")
        : ["00", "00", "00"];
      return { hours, minutes, seconds };
    });
    useEffect(() => {
      const normalized = normalizeRuntime(value);
      const [hours, minutes, seconds] = normalized
        ? normalized.split(":")
        : ["00", "00", "00"];
      setTime({ hours, minutes, seconds });
    }, [value]);

    // Handle changes to individual dropdowns
    const handleTimeChange = (field) => (e) => {
      const newTime = { ...time, [field]: e.target.value };
      setTime(newTime);
      // Update formData.runtime with formatted time
      const formattedTime = `${newTime.hours.padStart(
        2,
        "0"
      )}:${newTime.minutes.padStart(2, "0")}:${newTime.seconds.padStart(
        2,
        "0"
      )}`;
      onChange(formattedTime);
    };

    // Generate options for hours (00-23), minutes (00-59), seconds (00-59)
    const hourOptions = Array.from({ length: 24 }, (_, i) =>
      i.toString().padStart(2, "0")
    );
    const minuteSecondOptions = Array.from({ length: 60 }, (_, i) =>
      i.toString().padStart(2, "0")
    );

    return (
      <div className="flex gap-2">
        <select
          value={time.hours}
          onChange={handleTimeChange("hours")}
          className="w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {hourOptions.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
        <span className="self-center text-gray-500">:</span>
        <select
          value={time.minutes}
          onChange={handleTimeChange("minutes")}
          className="w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {minuteSecondOptions.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
        <span className="self-center text-gray-500">:</span>
        <select
          value={time.seconds}
          onChange={handleTimeChange("seconds")}
          className="w-20 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {minuteSecondOptions.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <>
      <div className="text-center">{/* Optional header */}</div>

      <div className="space-y-4">


        <div>
          <label className="block text-sm font-medium text-gray-700">
            Genre
          </label>

          <CreatableMultiSelect
            field="genre"
            options={genreOptions}
            value={mapWithFallback(formData.genre, genreOptions, setGenreOptions)}
            onChange={(selectedOptions) =>
              handleDropdownChange(
                "genre",
                selectedOptions.map(opt => opt.value)
              )
            }
            placeholder="Search or create genres..."
            loadOptions={genreLoadOptions}
            additional={{ page: 1 }}
            setOptionsCallback={setGenreOptions}
          />
        </div>


        {/* Languages */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Languages
          </label>
          <CreatableMultiSelect
            field="languages"
            options={languagesOptions}
            value={mapWithFallback(formData.languages, languagesOptions, setLanguagesOptions)}
            onChange={(selectedOptions) =>
              handleDropdownChange(
                "languages",
                selectedOptions.map((opt) => opt.value)
              )
            }
            placeholder="Search or create languages..."
            loadOptions={languagesLoadOptions}
            additional={{ page: 1 }}
            setOptionsCallback={setLanguagesOptions}
          />
        </div>

        {/* Cast */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Cast Members
          </label>
          <CreatableMultiSelect
            field="cast"
            options={castOptions}
         value={(formData.cast || []).map(val => {
  const id = typeof val === "object" ? val.value : val;

  // non-UUID → already label
  if (!isUUID(id)) {
    return { value: id, label: id };
  }

  let found = castOptions.find(opt => opt.value === id);

  if (!found && id) {
    const newOption = { value: id, label: id };

    setCastMembersOptions(prev => {
      if (prev.some(opt => opt.value === id)) return prev;
      return [...prev, newOption];
    });

    found = newOption;
  }

  return found;
})}
           onChange={(selected) =>
  handleDropdownChange(
    "cast",
    (selected || []).map(opt => opt.value)
  )
}
            placeholder="Search or create cast members..."
            loadOptions={castLoadOptions}
            additional={{ page: 1 }}
            setOptionsCallback={setCastMembersOptions}
          />
        </div>


        {/* Director */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Director
          </label>
          <CreatableMultiSelect
            field="director"
            options={directorOptions}
            value={mapWithFallback(formData.director, directorOptions, setDirectorsOptions)}
            onChange={(selectedOptions) =>
              handleDropdownChange("director", selectedOptions.map(opt => opt.value))
            }
            loadOptions={directorLoadOptions}
            placeholder="Search directors..."
            setOptionsCallback={setDirectorsOptions}
          />
        </div>




        {/* Country */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Country
          </label>
          <select
            value={formData.country || ""}
            onChange={(e) => handleDropdownChange("country", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Select a country...</option>
            {countryList()
              .getData()
              .map((c) => (
                <option key={c.label} value={c.label}>
                  {c.label}
                </option>
              ))}
          </select>
        </div>

        {/* Writer */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Writer
          </label>
          <input
            type="text"
            value={formData.writer || ""}
            onChange={(e) => handleDropdownChange("writer", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Enter writer"
          />
        </div>



        <div>
          <label className="block text-sm font-medium text-gray-700">
            Run Time (HH:mm:ss) hrs.
          </label>
          <TimePicker
            value={formData.runtime}
            onChange={(value) => handleDropdownChange("runtime", value)}
          />
          <p className="text-xs text-gray-500 mt-1">
            Select time in 24-hour format (HH:mm:ss)
          </p>
        </div>

        {/* Year */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Year
          </label>
          <input
            type="number"
            value={formData.year || ""}
            onChange={(e) => handleDropdownChange("year", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="e.g. 2023"
          />
        </div>

        {/* IMDB Rating */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            IMDB Rating
          </label>
          <input
            type="number"
            step="0.1"
            min="0"
            max="10"
            value={formData.rating || ""}
            onChange={(e) => handleDropdownChange("rating", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="e.g. 7.8"
          />
        </div>

        {/* IMDB ID */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            IMDB ID
          </label>
          <input
            type="text"
            value={formData.imdb_id || ""}
            onChange={(e) => handleDropdownChange("imdb_id", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="e.g. tt1234567"
          />
        </div>

        {/* Tags */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Tags
          </label>

          <CreatableAsyncPaginate
            isMulti
            loadOptions={loadTags}
            additional={{ page: 1 }}
            styles={selectStyles}
            menuPortalTarget={document.body}
            value={
              Array.isArray(formData.tags)
                ? formData.tags.map((tag) => ({ value: tag, label: tag }))
                : []
            }
            onChange={(selected) => {
              const tags = (selected || []).map((opt) => opt.value);
              handleDropdownChange("tags", tags);
            }}
            onCreateOption={(inputValue) => {
              if (!inputValue?.trim()) return;
              const trimmed = inputValue.trim();
              setShowTagConfirm(true);
              setPendingTagValue(trimmed);
            }}
            placeholder="Search or create tag..."
          />
          <ConfirmTagModal
            show={showTagConfirm}
            onClose={() => setShowTagConfirm(false)}
            onConfirm={() => {
              const newTags = [
                ...(Array.isArray(formData.tags) ? formData.tags : []),
                pendingTagValue,
              ];
              handleDropdownChange("tags", newTags);
              setShowTagConfirm(false);
              setPendingTagValue("");
            }}
            pendingValue={pendingTagValue}
          /> 

        </div>

        {/* Synopsis */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Synopsis
          </label>
          <textarea
            value={formData.synopsis || ""}
            onChange={(e) => handleDropdownChange("synopsis", e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Enter a short synopsis"
            rows={4}
          />
        </div>
      </div>
    </>
  );
};

export default StepAdditionalMetadata;
